import { render, staticRenderFns } from "./ModuleBoxBadge.vue?vue&type=template&id=4dc5a1ff&scoped=true&"
import script from "./ModuleBoxBadge.vue?vue&type=script&lang=js&"
export * from "./ModuleBoxBadge.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBoxBadge.vue?vue&type=style&index=0&id=4dc5a1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5a1ff",
  null
  
)

export default component.exports